/* global BigInt */
import { validCents } from './cashMoney';

export const validBalance = (row) =>
  row?.schemaVersion === 1 &&
  row.currency === 'USD' &&
  typeof row.enabled === 'boolean' &&
  typeof row.spendingBlocked === 'boolean' &&
  validCents(row.balanceCents) &&
  validCents(row.revision) &&
  row.fundingAvailable === false;

export const validSettings = (row) =>
  row?.schemaVersion === 1 &&
  row.currency === 'USD' &&
  typeof row.enabled === 'boolean' &&
  /^[a-f\d]{24}$/i.test(row.distributorId) &&
  validCents(row.revision) &&
  row.rateScale === 10000 &&
  Number.isInteger(row.quoteValidityMinutes) &&
  row.quoteValidityMinutes >= 15 &&
  row.quoteValidityMinutes <= 1440 &&
  Array.isArray(row.products) &&
  new Set(row.products.map((product) => product.productId)).size === row.products.length &&
  row.products.every(
    (product) =>
      /^[a-f\d]{24}$/i.test(product.productId) &&
      typeof product.name === 'string' &&
      product.name.length > 0 &&
      typeof product.size === 'string' &&
      Number.isSafeInteger(product.unitsPerItem) &&
      product.unitsPerItem > 0
  ) &&
  Array.isArray(row.productRates) &&
  new Set(row.productRates.map((product) => `${product.productId}:${product.size}`)).size ===
    row.productRates.length &&
  row.productRates.every(
    (product) =>
      /^[a-f\d]{24}$/i.test(product.productId) &&
      typeof product.size === 'string' &&
      product.size.length > 0 &&
      Number.isSafeInteger(product.ratePerUnitScaled) &&
      product.ratePerUnitScaled > 0 &&
      product.ratePerUnitScaled <= 1000000000
  ) &&
  Array.isArray(row.shippingRanges) &&
  row.shippingRanges.length > 0 &&
  new Set(row.shippingRanges.map((range) => range.shippingSpeed)).size ===
    row.shippingRanges.length &&
  row.shippingRanges.every(
    (range) =>
      typeof range.shippingSpeed === 'string' &&
      range.shippingSpeed.length > 0 &&
      validCents(range.minCents) &&
      validCents(range.maxCents) &&
      range.minCents <= range.maxCents &&
      range.maxCents <= 1000000
  );

export function parseRate(value) {
  if (typeof value !== 'string' || !/^\d+(?:\.\d{1,4})?$/.test(value.trim())) return null;
  const [whole, fraction = ''] = value.trim().split('.');
  const scaled = BigInt(whole) * 10000n + BigInt(fraction.padEnd(4, '0'));
  return scaled > 0n && scaled <= BigInt(Number.MAX_SAFE_INTEGER) ? Number(scaled) : null;
}
export function displayRate(value) {
  return `${BigInt(value) / 10000n}.${String(value % 10000).padStart(4, '0')}`;
}
export function itemCostCents(rate, units) {
  if (!Number.isSafeInteger(rate) || rate <= 0 || !Number.isSafeInteger(units) || units <= 0)
    return null;
  const cost = (BigInt(rate) * BigInt(units) + 50n) / 100n;
  return cost > 0n && cost <= BigInt(Number.MAX_SAFE_INTEGER) ? Number(cost) : null;
}
